var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "date-picker-wrapper" },
    [
      _vm.label
        ? [
            _c(
              "label",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showLabel,
                    expression: "showLabel"
                  }
                ],
                staticClass: "date-picker-label",
                attrs: { id: _vm.labelId, for: _vm.inputId }
              },
              [
                _vm._v("\n\t\t\t" + _vm._s(_vm.label) + "\n\t\t\t"),
                _vm.required
                  ? _c("span", { staticClass: "required-asterisk" }, [
                      _vm._v("*")
                    ])
                  : _vm._e()
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.validateInput
        ? _c(
            "div",
            { staticClass: "input-group" },
            [
              _c("validation-provider", {
                attrs: {
                  name: _vm.validationName,
                  rules: _vm.validationInputRules
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return _c("div", {}, [
                          _c("input", {
                            ref: "input",
                            staticClass: "form-control date-input",
                            attrs: {
                              id: _vm.inputId,
                              type: "text",
                              name: _vm.name,
                              placeholder: _vm.placeholder,
                              disabled: _vm.disabled,
                              required: _vm.required,
                              readonly: !_vm.editable,
                              "aria-labelledby": _vm.label
                                ? _vm.labelId
                                : undefined,
                              "aria-describedby": _vm.errorMessage
                                ? _vm.errorMessage
                                : undefined,
                              "aria-invalid": _vm.errorMessage
                                ? "true"
                                : undefined
                            },
                            domProps: { value: _vm.displayValue },
                            on: {
                              click: _vm.handleInputClick,
                              dblclick: _vm.setToday,
                              blur: _vm.handleBlur,
                              input: _vm.handleInput,
                              change: _vm.handleChange,
                              keydown: [
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "space",
                                      32,
                                      $event.key,
                                      [" ", "Spacebar"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.openCalendar($event)
                                },
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.openCalendar($event)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              attrs: { id: _vm.describedByID }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(_vm.datePickerInputMessage) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "input-group-append",
                              staticStyle: { "white-space": "nowrap" }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary calendar-btn",
                                  attrs: {
                                    type: "button",
                                    "aria-expanded": _vm.isOpen
                                      ? "true"
                                      : "false",
                                    "aria-haspopup": "dialog",
                                    "aria-label": _vm.triggerAriaLabel,
                                    disabled: _vm.disabled
                                  },
                                  on: { click: _vm.toggleCalendar }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-calendar",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("small", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(errors[0]))
                          ])
                        ])
                      }
                    }
                  ],
                  null,
                  false,
                  161443389
                )
              })
            ],
            1
          )
        : _c("div", { staticClass: "input-group" }, [
            _c("input", {
              ref: "input",
              staticClass: "form-control date-input",
              attrs: {
                id: _vm.inputId,
                type: "text",
                name: _vm.name,
                placeholder: _vm.placeholder,
                disabled: _vm.disabled,
                required: _vm.required,
                readonly: !_vm.editable,
                "aria-labelledby": _vm.label ? _vm.labelId : undefined,
                "aria-describedby": _vm.errorMessage
                  ? _vm.errorMessage
                  : undefined,
                "aria-invalid": _vm.errorMessage ? "true" : undefined
              },
              domProps: { value: _vm.displayValue },
              on: {
                click: _vm.handleInputClick,
                dblclick: _vm.setToday,
                blur: _vm.handleBlur,
                input: _vm.handleInput,
                change: _vm.handleChange,
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar"
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.openCalendar($event)
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.openCalendar($event)
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { id: _vm.describedByID }
              },
              [
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.datePickerInputMessage) + "\n\t\t"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "input-group-append",
                staticStyle: { "white-space": "nowrap" }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary calendar-btn",
                    attrs: {
                      type: "button",
                      "aria-expanded": _vm.isOpen ? "true" : "false",
                      "aria-haspopup": "dialog",
                      "aria-label": _vm.triggerAriaLabel,
                      disabled: _vm.disabled
                    },
                    on: { click: _vm.toggleCalendar }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-calendar",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ]
            )
          ]),
      _vm._v(" "),
      _vm.errorMessage
        ? _c(
            "div",
            {
              staticClass: "invalid-feedback d-block",
              attrs: { id: _vm.errorId, role: "alert" }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.errorMessage) + "\n\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpen
        ? _c(
            "div",
            {
              ref: "dialog",
              staticClass: "calendar-dialog mx-calendar",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": _vm.label ? _vm.labelId : "calendar-dialog"
              },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.closeCalendar($event)
                },
                "!keydown": function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                  ) {
                    return null
                  }
                  return _vm.trapFocus($event)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "calendar-container" },
                [
                  _c("wc-datepicker", {
                    ref: "wcPicker",
                    attrs: {
                      disabled: _vm.disabled,
                      locale: _vm.locale !== "sa-us" ? _vm.locale : "en-us",
                      "first-day-of-week": _vm.firstDayOfWeek,
                      range: _vm.range,
                      "show-today-button": false,
                      "show-clear-button": _vm.showClearButton,
                      "start-date": _vm.startDateIso,
                      value: _vm.valueIso
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "calendar-actions text-center" }, [
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary today-button",
                        attrs: { type: "button" },
                        on: { click: _vm.setToday }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.todayButtonLabel) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpen
        ? _c("div", {
            staticClass: "calendar-backdrop",
            on: { click: _vm.closeCalendar }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }